const ALLOWED_WEBHOOK_EVENTS = {
  ENTRY_PUBLISH: 'entry.publish',
  ENTRY_UNPUBLISH: 'entry.unpublish',
};

export { ALLOWED_WEBHOOK_EVENTS };
